export class XHRApi {

    http;
    headers;
    $callbacks = {};

    constructor(headers = {}) { // the constructor
        this.http = new XMLHttpRequest();
        this.headers = headers
        this.settings()
    }

    getCallbacks() {
        return this.$callbacks;
    }

    settings() {
        this.getCallbacks().callbacks = {
            onProgress: null
        }
    }

    checkIfCallbackIsSet() {
        if (!this.getCallbacks().callbacks) {
            throw new DOMException('No Callbacks exist')
        }
        return true
    }

    /**
     * Add onProgress callback
     * @param $onProgress
     */
    onProgress($onProgress) {
        if (this.checkIfCallbackIsSet()) {
            this.getCallbacks().callbacks.onProgress = $onProgress;
            return this;
        }

    }

    /**
     * GET Method
     * @param url
     * @param callBack
     *  - successCallBack
     * - errorCallBack
     * @constructor
     */
    Get(url, callBack) {
        this.getHttp().open('GET', url, true);

        this.setHeaders();

        this.getHttp().send();

        let self = this;
        this.getHttp().onreadystatechange = function () { // Callback function
            try {
                if (self.http.readyState === XMLHttpRequest.DONE) {
                    if (self.http.status === 200) {
                        callBack(null, self.http.response); // <- return the callback here:
                    } else {
                        callBack(self.http.response); // <- Another callback
                    }
                }
            } catch (e) {
                callBack('Something Went Wrong: ' + e.description);
            }
        }
    } // End of Get method --  XHRApi.Get(url, )

    /**
     * POST Method
     * @param url
     * @param data
     * @param callBack
     * @constructor
     */
    Post(url, data, callBack) {

        this.getHttp().open('POST', url, true)
        this.setHeaders();
        this.getHttp().send(data);

        let self = this;

        let onProgress = self.getCallbacks().callbacks.onProgress;
        if (onProgress !== null && typeof onProgress == 'function') {
            // Update progress (can be used to show progress indicator)
            this.getHttp().upload.addEventListener("progress", function (e) {
                onProgress(e)
            })
        }

        this.getHttp().onreadystatechange = function () { // Callback function
            try {
                self.http.onload = function () {
                    callBack(null, self.http.responseText);
                }
            } catch (e) {
                callBack('Something Went Wrong: ' + e.description);
            }
        }

    }

    /**
     * PUT Method
     * @param url
     * @param data
     * @param callBack
     * @constructor
     */
    Put(url, data, callBack) {

        this.getHttp().open('PUT', url, true);
        this.setHeaders();
        this.getHttp().send(data);

        let self = this;
        let onProgress = self.getCallbacks().callbacks.onProgress;
        if (onProgress !== null && typeof onProgress == 'function') {
            // Update progress (can be used to show progress indicator)
            this.getHttp().upload.addEventListener("progress", function (e) {
                onProgress(e)
            });
        }
        try {
            this.http.onload = function () {
                if (self.http.status === 200) {
                    callBack(null, self.http.response); // <- return the callback here:
                } else {
                    callBack(self.http.response); // <- Another callback
                }
            }
        } catch (e) {
            callBack('Something Went Wrong: ' + e.description);
        }

    }

    /**
     * DELETE METHOD
     * @param url
     * @param data
     * @param callBack
     * @constructor
     */
    Delete(url, data = null, callBack) {

        this.http.open('DELETE', url, true);
        this.setHeaders();

        if (data) {
            this.http.send(data);
        } else {
            this.http.send();
        }

        let self = this;
        try {
            this.http.onload = function () {
                if (self.http.status === 200) {
                    callBack(null, self.http.response);
                } else {
                    callBack(self.http.response)
                }
            }
        } catch (e) {
            callBack('Something Went Wrong: ' + e.description);
        }
    }

    getHeaders() {
        return this.headers;
    }

    setHeaders() {
        if (this.getHeaders()) {
            for (let key in this.getHeaders()) {
                this.getHttp().setRequestHeader(key, this.getHeaders()[key]);
            }
        }
    }

    getHttp() {
        return this.http;
    }

}

